module.exports = __webpack_public_path__ + "static/Gilroy-Light-085f3ee361c9b80e0ccf8a703da9efe6.woff2";